const CHECKOUT_COMPLETE_KEY = 'checkoutCompleteAt';

export function markCheckoutComplete() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(CHECKOUT_COMPLETE_KEY, String(Date.now()));
}

export function clearCheckoutCompleteMarker() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(CHECKOUT_COMPLETE_KEY);
}

export function hasCheckoutCompleteMarker() {
  if (typeof window === 'undefined') {
    return false;
  }

  return Boolean(window.localStorage.getItem(CHECKOUT_COMPLETE_KEY));
}
